"use client";

import Link from "next/link";
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";
import type { IPlatformLink } from "@/helpers/platformCrossLinks";
import { StyledSection } from "./platformCrossLinks.styles";

interface IPlatformCrossLinksProps {
  platform: IPlatformLink;
  others: IPlatformLink[];
  // Directly under <SupportedPlatforms />, whose bottom padding already spaces the section.
  afterTiles?: boolean;
}

export const PlatformCrossLinks = ({ platform, others, afterTiles }: IPlatformCrossLinksProps) => (
  <StyledSection aria-label="Platforms" className={afterTiles ? "after-tiles" : undefined}>
    <Link className="own" href={`/platforms/${platform.slug}`}>
      See every widget for {platform.title}
      <IoIosArrowForward className="icon" aria-hidden="true" />
    </Link>
    {others.length > 0 && (
      <>
        <p className="label">Building on another platform?</p>
        <ul>
          {others.map((p) => (
            <li key={p.slug}>
              <Link href={`/platforms/${p.slug}`}>{p.title}</Link>
            </li>
          ))}
        </ul>
      </>
    )}
  </StyledSection>
);
